import { useSelector } from "react-redux";
import { useMemo } from "react";
import type { RootState } from "../store/reducer";

type Permissions = Record<string, boolean> | null | undefined;

const useHasPermission = (permissionKey: string): boolean => {
  const permissions: Permissions = useSelector((state: RootState) => state.user?.permission);
  return useMemo(() => {
    if (!permissions) return false;

    return Boolean(permissions[permissionKey]);
  }, [permissions, permissionKey]);
};

export default useHasPermission;
